export function triggerEvent(element, event_name = '', args = {}) {
    let event;
    if (document.createEvent) {
        event = document.createEvent("HTMLEvents");
        event.initEvent(event_name, true, true);
    } else {
        event = document.createEventObject();
        event.eventType = event_name;
    }

    event.eventName = event_name;
    event.SmArgs = args;

    if (document.createEvent) {
        element.dispatchEvent(event);
    } else {
        element.fireEvent("on" + event.eventType, event);
    }
}


// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/helpers.js